import React from 'react';
import { Descriptions } from 'antd';
import FormatDimension from '../FormatDimension';
import QuickTurnPartStore from 'stores/QuickTurnPartStore';
import RenamePart from '../RenamePart';

const PartSummaryTable = () => {
    const {
        name,
        overallLength,
        outerDiameter,
        hasThruHole,
        innerDiameter,
        hasFlange,
        flangeDiameter,
        flangeThickness,
        hasFrontCounterbore,
        frontCounterboreDiameter,
        frontCounterboreDepth,
        hasFrontCountersink,
        frontCountersinkDepth,
        frontCountersinkAngle,
        chamferWidth,
    } = QuickTurnPartStore;

    const material = QuickTurnPartStore.materials?.find(x => x.id === QuickTurnPartStore.material);

    return (
        <div className="p-3">
            {/* Hide until bug is fixed */}
            {/* <RenamePart /> */}
            <Descriptions bordered layout="horizontal" column={1} size="small">
                <Descriptions.Item label="Part Name">{name}</Descriptions.Item>
                <Descriptions.Item label="Material">{`${material?.type} ${material?.alloy}`}</Descriptions.Item>
                <Descriptions.Item label="Overall Length">
                    <FormatDimension value={overallLength} unit="inch" />
                </Descriptions.Item>
                <Descriptions.Item label="Outer Diameter">
                    <FormatDimension value={outerDiameter} unit="inch" />
                </Descriptions.Item>
                <Descriptions.Item label="Has Through-Hole">{hasThruHole ? 'Yes' : 'No'}</Descriptions.Item>
                {hasThruHole ? (
                    <Descriptions.Item label="Inner Diameter">
                        <FormatDimension value={innerDiameter} unit="inch" />
                    </Descriptions.Item>
                ) : null}
                <Descriptions.Item label="Has Flange">{hasFlange ? 'Yes' : 'No'}</Descriptions.Item>
                {hasFlange ? (
                    <>
                        <Descriptions.Item label="Flange Diameter">
                            <FormatDimension value={flangeDiameter} unit="inch" />
                        </Descriptions.Item>
                        <Descriptions.Item label="Flange Length">
                            <FormatDimension value={flangeThickness} unit="inch" />
                        </Descriptions.Item>
                    </>
                ) : null}
                <Descriptions.Item label="Has Counterbore">{hasFrontCountersink ? 'Yes' : 'No'}</Descriptions.Item>
                {hasFrontCounterbore ? (
                    <>
                        <Descriptions.Item label="Counterbore Diameter">
                            <FormatDimension value={frontCounterboreDiameter} unit="inch" />
                        </Descriptions.Item>
                        <Descriptions.Item label="Counterbore Depth">
                            <FormatDimension value={frontCounterboreDepth} unit="inch" />
                        </Descriptions.Item>
                    </>
                ) : null}
                <Descriptions.Item label="Has Countersink">{hasFrontCountersink ? 'Yes' : 'No'}</Descriptions.Item>
                {hasFrontCountersink ? (
                    <>
                        <Descriptions.Item label="Countersink Angle">
                            <FormatDimension value={frontCountersinkAngle} unit="angle" />
                        </Descriptions.Item>
                        <Descriptions.Item label="Countersink Depth">
                            <FormatDimension value={frontCountersinkDepth} unit="inch" />
                        </Descriptions.Item>
                    </>
                ) : null}
                <Descriptions.Item label="Chamfer Size">
                    <FormatDimension value={chamferWidth} unit="inch" />
                </Descriptions.Item>
            </Descriptions>
        </div>
    );
};

export default PartSummaryTable;
